import { axios } from 'api'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import styled, { keyframes } from 'styled-components'

const FieldWrapper = styled.form`
  padding: 12px 14px;
  background: #f8fafc;
  border: 1.5px solid #e3e8ee;
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(60, 72, 88, 0.04);
  input {
    font-size: 14px;
  }
`

const StyledLabel = styled.label`
  font-weight: 600;
  color: #1a2636;
  margin-bottom: 8px;
  font-size: 14px;
  letter-spacing: 0.01em;
  display: block;
`

const StyledDescription = styled.div`
  color: #6c757d;
  font-size: 1rem;
  margin-bottom: 14px;
  line-height: 1.5;
  font-size: 12px;
`

const InputFlex = styled.div`
  display: flex;
  align-items: center;
  gap: 18px;
`

const StyledInput = styled.input`
  max-width: 270px;

  border-radius: 7px;
  border: 1.5px solid #d0d7de;
  padding: 8px 14px;
  transition: border-color 0.2s, box-shadow 0.2s;
  &:focus {
    border-color: #388bff;
    box-shadow: 0 0 0 2px #388bff22;
    outline: none;
  }
  &:disabled {
    background: #f1f3f7;
    color: #a0a4ab;
  }
`

const StyledCheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
  gap: 10px;
  .form-check-label {
    margin-bottom: 0;
    font-size: 12px;
  }
`

const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`

const IconButton = styled.button`
  border: none;
  background: ${({ color }) => color || '#e9ecef'};
  color: ${({ fontcolor }) => fontcolor || '#222'};
  border-radius: 6px;
  height: 30px;
  width: 30px;
  font-size: 20px;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(60, 72, 88, 0.04);
`
const fadeInOut = keyframes`
  0% { opacity: 0; }
  10% { opacity: 1; }
  90% { opacity: 1; }
  100% { opacity: 0; }
`
const SavedMsg = styled.span`
  color: #388b45;
  font-weight: 500;
  font-size: 12px;
  margin-left: 10px;
  font-weight: 600;
  opacity: 0;
  animation: ${fadeInOut} 1.5s linear;
  user-select: none;
`
const ConfigField = ({ config }) => {
  const [value, setValue] = useState(config.value)
  const [savedValue, setSavedValue] = useState(config.value)
  const [showSaved, setShowSaved] = useState(false)

  useEffect(() => {
    setValue(config.value)
    setSavedValue(config.value)
  }, [config])
  const [editing, setEditing] = useState(false)
  const handleSave = async (e) => {
    e.preventDefault()
    setEditing((state) => !state)
    if (value === savedValue) return

    try {
      const res = await axios.post(
        '/admin_configs/update_config',
        { value, key: config.key },
        {
          baseURL: '/admin'
        }
      )
      if (res?.data?.success) {
        setSavedValue(value)
        setShowSaved(true)
        setTimeout(() => setShowSaved(false), 2000)
      }
    } catch (err) {}
  }
  return (
    <FieldWrapper onSubmit={handleSave}>
      <StyledLabel htmlFor={config.key}>{config.title}</StyledLabel>
      <StyledDescription>{config.description}</StyledDescription>
      <InputFlex>
        {config.type === 'date' && (
          <StyledInput
            as='input'
            type='date'
            className='form-control'
            id={config.key}
            name={config.key}
            value={value ? moment(value).format('YYYY-MM-DD') : ''}
            readOnly={!editing}
            onChange={(e) => {
              const val = moment(e.target.value).format('YYYY-MM-DD')
              setValue(val === 'Invalid date' ? '' : val)
            }}
          />
        )}
        {config.type === 'boolean' && (
          <StyledCheckboxWrapper className='form-check'>
            <label className='form-check-label' htmlFor={config.key}>
              {config.title}
            </label>
            <input
              type='checkbox'
              className='form-check-input'
              id={config.key}
              name={config.key}
              checked={value}
              disabled={!editing}
              onChange={() => setValue((state) => !state)}
              style={{ width: 22, height: 22, accentColor: '#388bff' }}
            />
          </StyledCheckboxWrapper>
        )}
        {config.type === 'text' && (
          <StyledInput
            as='input'
            type='text'
            className='form-control'
            id={config.key}
            name={config.key}
            placeholder={config.title}
            value={value}
            readOnly={!editing}
            onChange={(e) => setValue(e.target.value)}
          />
        )}
        <ButtonGroup className='flex-box'>
          {editing ? (
            <>
              <IconButton
                type='button'
                title='Cancel'
                color='#f1f3f7'
                fontcolor='#888'
                hovercolor='#e3e8ee'
                hoverfontcolor='#222'
                onClick={() => setEditing(false)}
              >
                ↩️
              </IconButton>
              <IconButton
                title='Save'
                type='submit'
                fontcolor='#fff'
                hoverfontcolor='#fff'
              >
                ✅
              </IconButton>
            </>
          ) : (
            <IconButton
              title='Edit'
              type='button'
              color='#e9ecef'
              fontcolor='#1976d2'
              hovercolor='#d0ebff'
              hoverfontcolor='#1976d2'
              onClick={() => setEditing(true)}
            >
              ✎
            </IconButton>
          )}
          {showSaved && <SavedMsg>Saved </SavedMsg>}
        </ButtonGroup>
      </InputFlex>
    </FieldWrapper>
  )
}

export default ConfigField
